import { CtasType } from '@photosi/rn-components/modals/dynamic-modals/modal-quality-alert/ModalQualityAlert.constants';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { SECTION_NAMES } from 'src/constants/sectionNames.contants';
import { useStore } from 'src/contexts/StoreContext';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import {
  DYNAMIC_MODAL_VIEWS,
  MODAL_QUALITY_OPEN_POINTS,
} from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { ProductModelInstance } from 'src/store/_models/product';

/**
 * useGridItemContentFooterLogicV3
 *
 * Handles hover state for the action icons in GridItemContentFooterV3.
 * The actual fade animations are handled by FadeIn/FadeOut in the component.
 */

export const useGridItemContentFooterLogicV3 = (product: ProductModelInstance) => {
  const { dynamicModal, project } = useStore();
  const { isMobile } = useResponsiveScreen();

  const onPressQuality = (options = false) => {
    const userImage = product.userImagesWithQualityAlert[0];
    dynamicModal?.openModal({
      qualityAlertUserImage: userImage,
      modalQualitySuggestions: userImage.qualitySuggestions,
      modalQualityCtas: CtasType.CLOSE,
      modalQualityOpenPoint: MODAL_QUALITY_OPEN_POINTS.photo,
      dynamicModalView: DYNAMIC_MODAL_VIEWS.QualityAlert,
      actionCallback: () => {},
    });
    amplitude.trackEvent(AnalyticsEvents.personalize.qualityAlertClick, {
      section_name: options ? SECTION_NAMES.OPTIONS_MENU : SECTION_NAMES.PERSONALIZE,
    });
  };
  const showQualityAlert = product.userImagesWithQualityAlert.length > 0;
  const avoidWidthImage = isMobile && project.activeProject?.gridColumns === 2;

  return {
    onPressQuality,
    avoidWidthImage,
    showQualityAlert,
  };
};
